// Ícones de traço (2 px), os mesmos dos apps (ui-native/Icone): grade 24×24.
// Os do balcão (busca, conversa, tel...) vêm do protótipo aprovado (quadro do balcão, 22/10/2026).
const CAMINHOS = {
  pedidos: 'M8 6h13M8 12h13M8 18h13M3 6h.01M3 12h.01M3 18h.01',
  clientes: 'M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2M9 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8',
  entregadores:
    'M5 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0M15 17a2 2 0 1 0 4 0 2 2 0 0 0-4 0M7 17h8M5 17H3v-4l3-5h6l3 5h4v4h-2',
  configuracoes:
    'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M19.4 15a1.7 1.7 0 0 0 .3 1.8l.1.1a2 2 0 1 1-2.8 2.8l-.1-.1a1.7 1.7 0 0 0-1.8-.3 1.7 1.7 0 0 0-1 1.5V21a2 2 0 1 1-4 0v-.1a1.7 1.7 0 0 0-1.1-1.5 1.7 1.7 0 0 0-1.8.3l-.1.1a2 2 0 1 1-2.8-2.8l.1-.1a1.7 1.7 0 0 0 .3-1.8 1.7 1.7 0 0 0-1.5-1H3a2 2 0 1 1 0-4h.1a1.7 1.7 0 0 0 1.5-1.1 1.7 1.7 0 0 0-.3-1.8l-.1-.1a2 2 0 1 1 2.8-2.8l.1.1a1.7 1.7 0 0 0 1.8.3H9a1.7 1.7 0 0 0 1-1.5V3a2 2 0 1 1 4 0v.1a1.7 1.7 0 0 0 1 1.5 1.7 1.7 0 0 0 1.8-.3l.1-.1a2 2 0 1 1 2.8 2.8l-.1.1a1.7 1.7 0 0 0-.3 1.8V9a1.7 1.7 0 0 0 1.5 1H21a2 2 0 1 1 0 4h-.1a1.7 1.7 0 0 0-1.5 1z',
  sol: 'M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4',
  lua: 'M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5z',
  automatico: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18M12 3v18',
  sair: 'M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9',
  busca: 'M17.5 11a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0M20 20l-4.2-4.2',
  conversa: 'M4.5 19.5l1.2-3.6A7.5 7.5 0 1 1 8.4 18.6z',
  tel: 'M6.6 3.8l2.6.4 1.2 3.4-1.7 1.3a10.5 10.5 0 0 0 4.4 4.4l1.3-1.7 3.4 1.2.4 2.6c-.2 1.3-1.3 2.3-2.6 2.2A14.5 14.5 0 0 1 4.4 6.4C4.3 5.1 5.3 4 6.6 3.8z',
  check: 'M5 12.5l4.2 4.2L19 7',
  alerta: 'M12 4l9 16H3zM12 10v4.5M12 17.5h.01',
  desfazer: 'M9 7L4.5 11.5 9 16M5 11.5h9.5a5 5 0 0 1 0 10H12',
  semRede:
    'M3 3l18 18M8.5 16.5a5 5 0 0 1 7 0M5 13a10 10 0 0 1 4.5-2.6M14.5 10.4A10 10 0 0 1 19 13M2 9.5a15 15 0 0 1 4.6-2.8M12 20h.01',
  impressora:
    'M7 9V4h10v5M7 17H5a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-2M7 14h10v6H7z',
  reticencias: 'M5 12h.01M12 12h.01M19 12h.01',
  baixo: 'M6 9l6 6 6-6',
  volta: 'M19 12H5M11 6l-6 6 6 6',
  seta: 'M5 12h14M13 6l6 6-6 6',
  relogio: 'M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0M12 8v4l2.5 2',
  repetir: 'M17 2l4 4-4 4M3 11V9a3 3 0 0 1 3-3h15M7 22l-4-4 4-4M21 13v2a3 3 0 0 1-3 3H3',
  pino: 'M12 21s7-6.3 7-12a7 7 0 1 0-14 0c0 5.7 7 12 7 12zM12 11.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5',
} as const;

export type NomeIcone = keyof typeof CAMINHOS;

// Os pontos das reticências somem com o traço fino.
const ESPESSURA: Partial<Record<NomeIcone, number>> = { reticencias: 3 };

export function Icone({ nome, tamanho = 20 }: { nome: NomeIcone; tamanho?: number }) {
  return (
    <svg
      width={tamanho}
      height={tamanho}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={ESPESSURA[nome] ?? 2}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={CAMINHOS[nome]} />
    </svg>
  );
}
